module.exports = __webpack_public_path__ + "static/media/my-detail-blue.0e1e4302.svg";